import React from 'react';
import componentServices from 'Scripts/componentServices';
import OperationsJobs from './operationsJobs';
import OperationsProvider from 'Scripts/contexts/operationsProvider';

componentServices.router.addRoutes([{
	path: '/operations/jobs',
	component: (props) => <OperationsProvider { ...props}><OperationsJobs store={ props.store } /></OperationsProvider>,
	contentClass: '',
	onEnter: componentServices.router.requireUser(componentServices.router.requireModule('operations'))
}, {
	path: '/operations',
	onEnter: ({ replace }) => {
		replace('/operations/jobs');
		// cancel the route transition
		return false;
	}
}]);